import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Swal from 'sweetalert2';
import Select from "react-select";
import DataTable from "react-data-table-component";

function MedSheet() {
    const [ldata, setLdata] = useState(null);
    const [dropdownOpenIndex, setDropdownOpenIndex] = useState(null);
    const [isAdmin, setIsAdmin] = useState('');
    const [otUhidSuggestions, setOtUhidSuggestions] = useState([]);
    const [image, setImage] = useState('');
    const [watermarkImage, setWatermarkImage] = useState('');
    const [footerImage, setFooterImage] = useState('');
    const [options, setOptions] = useState([]); // Dropdown medicines
    const [selectedMedicines, setSelectedMedicines] = useState([]); // Selected medicines with qty
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [hasLoadedPrefill, setHasLoadedPrefill] = useState(false);
    
    const [fromDate, setFromDate] = useState(''); // ✅ NEW
    const [toDate, setToDate] = useState(''); // ✅ NEW
    const [searchKey, setSearchKey] = useState('');
    const [searchDate, setSearchDate] = useState(''); // ✅ NEW
    const [formData, setFormData] = useState({
        l1: [],
        doc: [],
        wards: [],
        page_no: 0,
        med_sheet_id: '',
        med_sheet_ipd_number: '',
        med_sheet_patient: '',
        med_sheet_consultant: '',
        med_sheet_given_by: '',
        med_sheet_medicine: '',
        med_uhid: '',
        med_sheet_room: '',
        med_sheet_panel: '',
        med_sheet_date: '',
        med_sheet_time: '',
        med_sheet_qty: '',
        med_sheet_remark: '',
        med_sheet_user: '',
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        isAlert: false,
    });

    // ==================== PREFILL LOADING ====================
    useEffect(() => {
        if (hasLoadedPrefill) return;

        const raw = sessionStorage.getItem("medsheet_prefill");
        if (!raw) return;

        const loadPrefill = async () => {
            try {
                const prefill = JSON.parse(raw);
                console.log("🔍 MedSheet prefill loaded:", prefill);

                setFormData((prev) => ({
                    ...prev,
                    med_sheet_ipd_number: prefill.ipd_uhid || prefill.uhid || prefill.ot_uhid_no || "",
                    med_sheet_patient: prefill.ipd_patient_name || prefill.name || prefill.ot_patient_name || "",
                    med_sheet_consultant: prefill.ot_ref_doctor || prefill.ipd_refer_doctor || "",
                    med_sheet_room: prefill.ipd_ward || "",
                    med_sheet_panel: prefill.ipd_bed || "",
                    med_uhid: prefill.ipd_uhid || prefill.uhid || prefill.ot_uhid_no || "",
                    med_ipd: prefill.ipd_id || prefill.ipd_no || "",
                }));

                toast.info("Patient data loaded from IPD/OT");
                setHasLoadedPrefill(true);
                sessionStorage.removeItem("medsheet_prefill");
            } catch (err) {
                console.error("Error loading MedSheet prefill:", err);
            }
        };

        loadPrefill();
    }, [hasLoadedPrefill]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if ((name + "").localeCompare("search_key") == 0) {
            initData();
        }
    };
// ==================== CLEAR FILTERS HANDLER ====================
const handleClearFilters = () => {
  const today = new Date();
  const formattedDate = today.toISOString().split("T")[0];
  
  // Reset all filter states to today
  setFromDate(formattedDate);
  setToDate(formattedDate);
  setSearchKey('');
  setSearchDate(formattedDate);
  
  // Fetch data with current date
  handleDateRangeSearch(formattedDate, formattedDate);
  
  toast.info("Filters cleared - showing today's records");
};

// ==================== DATE RANGE SEARCH HANDLER ====================
const handleDateRangeSearch = async (from, to) => {
  const storedData = sessionStorage.getItem("ldata");
  if (storedData) {
      const fd = new FormData();
      fd.append('page_no', '0');
      fd.append('search_key', searchKey);
      fd.append('from_date', from);
      fd.append('to_date', to);

      try {
          const response = await axios.post(
              AppConst.BASE_URL + AppConst.getMedSheetListUrl,
              fd,
              { headers: { 'Content-Type': 'multipart/form-data' } }
          );

          if (response.data.status) {
              const records = response.data.records;
              if (records != null && records != undefined) {
                  setFormData(prev => ({
                      ...prev,
                      l1: records
                  }));
              }
          }
      } catch (error) {
          console.error("Date range search error:", error);
      }
  }
};
// ==================== SEARCH HANDLER ====================
const handleSearch = async (keyword) => {
  const storedData = sessionStorage.getItem("ldata");
  if (storedData) {
      const fd = new FormData();
      fd.append('page_no', '0');
      fd.append('search_key', keyword);
      if (fromDate) fd.append('from_date', fromDate);
      if (toDate) fd.append('to_date', toDate);

      try {
          const response = await axios.post(
              AppConst.BASE_URL + AppConst.getMedSheetListUrl,
              fd,
              { headers: { 'Content-Type': 'multipart/form-data' } }
          );

          if (response.data.status) {
              const records = response.data.records;
              if (records != null && records != undefined) {
                  setFormData(prev => ({
                      ...prev,
                      l1: records
                  }));
              }
          }
      } catch (error) {
          console.error("Search error:", error);
      }
  }
};

// ==================== FORMAT HELPERS ====================
const formatTimeTo12Hour = (time24) => {
  if (!time24) return 'N/A';
  const [hours, minutes] = time24.split(':');
  const hour = parseInt(hours);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour % 12 || 12;
  return `${hour12}:${minutes} ${ampm}`;
};

const formatDateToDDMMMYYYY = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};
    const handleChange1 = (e, index) => {
        if (!e || !e.target) return;
        const { name, value } = e.target;
        const name1 = name.replace(/[0-9]/g, "");

        setFormData(prev => {
            const updatedItems = [...prev.medicines];
            updatedItems[index] = {
                ...updatedItems[index],
                [name1]: value
            };

            return {
                ...prev,
                medicines: updatedItems
            };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const fd = new FormData();

        fd.append('med_sheet_id', formData.med_sheet_id);
        fd.append('med_sheet_ipd_number', formData.med_sheet_ipd_number);
        fd.append('med_sheet_patient', formData.med_sheet_patient);
        fd.append('med_sheet_consultant', formData.med_sheet_consultant);
        fd.append('med_sheet_given_by', formData.med_sheet_given_by);
        fd.append('med_sheet_medicine', JSON.stringify(formData.med_sheet_medicine));
        fd.append('med_uhid', formData.med_uhid);
        fd.append('med_ipd', formData.med_ipd);
        fd.append('med_sheet_room', formData.med_sheet_room);
        fd.append('med_sheet_panel', formData.med_sheet_panel);
        fd.append('med_sheet_date', formData.med_sheet_date);
        fd.append('med_sheet_time', formData.med_sheet_time);
        fd.append('med_sheet_qty', formData.med_sheet_qty);
        fd.append('med_sheet_remark', formData.med_sheet_remark);
        fd.append('med_sheet_user', ldata.user_id);

        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.addMedSheetUrl, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.data.status) {
                setFormData(prev => ({
                    ...prev,
                    med_sheet_id: '',
                    med_sheet_ipd_number: '',
                    med_sheet_patient: '',
                    med_sheet_consultant: '',
                    med_sheet_given_by: '',
                    med_sheet_medicine: '',
                    med_uhid: '',
                    med_sheet_room: '',
                    med_sheet_panel: '',
                    med_sheet_date: '',
                    med_sheet_time: '',
                    med_sheet_qty: '',
                    med_sheet_remark: '',
                    med_sheet_user: '',
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                }));
                toast.success(response.data.success);
                initData();
                setSelectedMedicines([]);
            }
            else {
                toast.error(response.data.success);
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                }));
            }
        } catch (error) {
            toast.error("Failed to save");
            setFormData(prev => ({
                ...prev,
                isAlert: true,
                alertMsg: "Failed",
                alertMsgTyp: "danger",
            }));
        }
    };

    const initData = async () => {
      const storedData = sessionStorage.getItem("ldata");
      const userData = JSON.parse(sessionStorage.getItem("ldata"));
      const roleId = userData?.role_id;
      if (roleId === 1 || roleId === "1") {
          setIsAdmin(true);
      } else {
          setIsAdmin(false);
      }
      if (storedData) {
          const fd = new FormData();
          fd.append('page_no', formData.page_no + "");
          fd.append('search_key', searchKey); // ✅ Use searchKey state
          
          // ✅ NEW: Use from/to dates if set, otherwise use searchDate
          if (fromDate && toDate) {
              fd.append('from_date', fromDate);
              fd.append('to_date', toDate);
          } else if (searchDate) {
              fd.append('search_date', searchDate);
          }
          
          try {
              const response = await axios.post(AppConst.BASE_URL + AppConst.getMedSheetListUrl, fd, {
                  headers: {
                      'Content-Type': 'multipart/form-data',
                  },
              });
              if (response.data.status) {
                  var records = response.data.records;
                  if (records != null && records != undefined) {
                      setFormData(prev => ({
                          ...prev,
                          l1: records
                      }));
                  }
              }
          } catch (error) {
              console.error("initData error:", error);
          }
      }
  };

    const initData2 = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            const fd = new FormData();
            fd.append('type', "doctor");
            fd.append('search_key', "");
            fd.append('page_no', 0);
            fd.append('user_cre_by', 1 + "");

            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                console.log("Doctor List Response:", JSON.stringify(response));
                if (response.data.status) {
                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            doc: records
                        }));
                    }
                }
            } catch (error) {
                console.error("initData2 error:", error);
            }
        }
    };

    const initData3 = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            const fd = new FormData();
            fd.append('par_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getBedListUrl1, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {
                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            wards: records
                        }));
                    }
                }
            } catch (error) {
                console.error("initData3 error:", error);
            }
        }
    };

    const handleEditClick = (item) => {
        setFormData((prev) => ({
            ...prev,
            med_sheet_id: item.med_sheet_id,
            med_sheet_ipd_number: item.med_sheet_ipd_number,
            med_sheet_patient: item.med_sheet_patient,
            med_sheet_consultant: item.med_sheet_consultant,
            med_sheet_given_by: item.med_sheet_given_by,
            med_uhid: item.med_uhid,
            med_ipd: item.med_ipd,
            med_sheet_room: item.med_sheet_room,
            med_sheet_panel: item.med_sheet_panel,
            med_sheet_date: item.med_sheet_date,
            med_sheet_time: item.med_sheet_time,
            med_sheet_remark: item.med_sheet_remark,
            med_sheet_user: item.med_sheet_user,
        }));

        const medicines = Array.isArray(item.med_sheet_medicine)
            ? item.med_sheet_medicine.map((m) => {
                const opt = options.find((o) => o.value == m.med_id);
                return {
                    value: opt ? opt.value : m.med_id,
                    label: opt ? opt.label : m.med_name,
                    qty: m.qty,
                };
            })
            : [];

        setSelectedMedicines(medicines);
    };

    const delItem = async (editItem) => {
        const confirm = await Swal.fire({
            title: 'Are you sure?',
            text: "Delete this Medical Sheet?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        });

        if (!confirm.isConfirmed) return;

        const fd = new FormData();
        fd.append('med_sheet_id', editItem.med_sheet_id + "");
        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.delMedSheetUrl, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.data.status) {
                toast.success("Deleted successfully");
                initData();
            }
        } catch (error) {
            toast.error("Failed to delete");
        }
    };

    useEffect(() => {
        console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
            initData2();
            initData3();
        }

        return () => {
            console.log('Component unmounted');
        };
    }, []);

    const searchOtUserNow = async (e) => {
        const uhid = e.target.value.trim();

        if (uhid.length < 3) {
            setOtUhidSuggestions([]);
            return;
        }

        try {
            const fd = new FormData();
            fd.append("lab_reg_uhid", uhid);

            const response = await axios.post(
                AppConst.BASE_URL + AppConst.searchUhidUrlCall,
                fd
            );
            console.log("OT UHID Search Response:", JSON.stringify(response.data));

            if (response.data.status) {
                setOtUhidSuggestions(response.data.records || []);
            } else {
                setOtUhidSuggestions([]);
            }
        } catch (error) {
            console.error("OT UHID Search Error:", error);
            setOtUhidSuggestions([]);
        }
    };

    const handleSelectOtUser = async (user) => {
        console.log("Selected User:", JSON.stringify(user));
        if (!user || !user.lab_reg_uhid) return;

        try {
            const admissionDateStr = user.lab_reg_date || user.ipd_reg_date;

            setFormData(prev => ({
                ...prev,
                med_sheet_ipd_number: user.lab_reg_uhid || "",
                med_sheet_patient: user.lab_reg_name || "",
                med_sheet_consultant: user.ipd_refer_doctor || "",
                med_sheet_room: user.ipd_ward || "",
                med_sheet_panel: user.ipd_bed || "",
                med_uhid: user.lab_reg_uhid || "",
                med_ipd: user.ipd_id || user.ipd_no || "", 
            }));

            toast.success(`${user.lab_reg_type} Patient data fetched successfully!`);
        } catch (err) {
            console.error("Error setting patient details:", err);
            toast.error("Failed to fetch patient details.");
        } finally {
            setOtUhidSuggestions([]);
        }
    };

    function getDoctorNameById(id) {
        const doctor = formData.doc.find(doc => doc.user_id === String(id));
        return doctor ? doctor.fname : " ";
    }

    function getWardNameById(wardId) {
        const ward = formData.wards.find(w => w.cat_id == wardId);
        return ward ? ward.cat_name : null;
    }

    function getBedNameById(bedId) {
        for (let ward of formData.wards) {
            const bed = ward.beds.find(b => {
                return b.bed_id == bedId;
            });

            if (bed) {
                return bed.bed_name;
            }
        }
        return null;
    }

    useEffect(() => {
      const today = new Date();
      const formattedDate = today.toISOString().split("T")[0];
      const formattedTime = today.toTimeString().slice(0, 5);
  
      setFormData(prev => ({
          ...prev,
          med_sheet_date: formattedDate,
          med_sheet_time: formattedTime
      }));
  
      // ✅ Set current date for both search and form
      setSearchDate(formattedDate);
      setFromDate(formattedDate); // ✅ NEW: Auto-set from date
      setToDate(formattedDate);   // ✅ NEW: Auto-set to date
      
      // ✅ Auto-fetch list on mount
      initData();
  }, []);

    const initData4 = async () => {
        setLoading(true);
        try {
            const storedData = sessionStorage.getItem("ldata");
            if (storedData) {
                const parsed = JSON.parse(storedData);
                const fd = new FormData();
                //fd.append("med_user", 1 + "");

                const response = await axios.post(
                    AppConst.BASE_URL + AppConst.getMedListUrl,
                    fd,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );

                console.log("Response : " + JSON.stringify(response.data.records))
                if (response.data.status && response.data.records) {
                    const meds = response.data.records.map((m) => ({
                        value: m.med_id,
                        label: m.med_name,
                    }));
                    setOptions(meds);
                }
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        initData4();
    }, []);

    const handleSelectChange = (selected) => {
        const withQty = selected.map((s) => {
            const existing = selectedMedicines.find((m) => m.value === s.value);
            return existing ? existing : { ...s, qty: 1 };
        });
        setSelectedMedicines(withQty);

        setFormData((prev) => ({
            ...prev,
            med_sheet_medicine: withQty.map((m) => ({
                med_id: m.value,
                med_name: m.label,
                qty: m.qty,
            })),
        }));
    };

    const handleQtyChange = (value, medId) => {
        const updated = selectedMedicines.map((m) =>
            m.value === medId ? { ...m, qty: Math.max(1, value) } : m
        );
        setSelectedMedicines(updated);

        setFormData((prev) => ({
            ...prev,
            med_sheet_medicine: updated.map((m) => ({
                med_id: m.value,
                med_name: m.label,
                qty: m.qty,
            })),
        }));
    };

    const handleRemove = (medId) => {
        const updated = selectedMedicines.filter((m) => m.value !== medId);
        setSelectedMedicines(updated);

        setFormData((prev) => ({
            ...prev,
            med_sheet_medicine: updated.map((m) => ({
                med_id: m.value,
                med_name: m.label,
                qty: m.qty,
            })),
        }));
    };

    const fetchConfigData = async () => {
        try {
            const res = await axios.post(
                `${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`
            );

            if (res.data.status) {
                const data = res.data;
                setImage(data.header_logo);
                setWatermarkImage(data.logo || '');
                setFooterImage(data.footer_logo || '');
            }
        }
        catch (err) {
            console.error("Error fetching config:", err);
        }
    };

    useEffect(() => {
        fetchConfigData()
    }, []);

    const imageUrlToBase64 = async (url) => {
        if (!url) {
            console.error("imageUrlToBase64: Provided URL is empty or invalid.");
            return null;
        }

        try {
            const response = await fetch(url, { cache: 'no-cache' });
            if (!response.ok) {
                console.error(`Failed to fetch image. URL: ${url}, Status: ${response.status} ${response.statusText}`);
                return null;
            }

            const blob = await response.blob();

            if (!blob.type.startsWith('image/')) {
                console.error(`The URL did not point to an image. URL: ${url}, MIME Type: ${blob.type}`);
                return null;
            }

            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = (error) => {
                    console.error("FileReader error:", error);
                    reject(error);
                };
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error("Error fetching or converting image. This might be a CORS issue.", { url, error });
            return null;
        }
    };

    console.log("medicine : " + JSON.stringify(formData.med_sheet_medicine))
    const generatePDF = async () => {
      if (!formData) {
          Swal.fire("Error", "Patient data is not available.", "error");
          return;
      }
  
      const doc = new jsPDF('p', 'mm', 'a4');
      const pageWidth = doc.internal.pageSize.getWidth();
      let y;
  
      const headerImageBase64 = await imageUrlToBase64(image);
      const headerImageHeight = 30;
  
      if (headerImageBase64) {
          doc.addImage(headerImageBase64, 'PNG', 0, 0, pageWidth, headerImageHeight);
      }
      y = headerImageHeight + 8;
  
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(14);
      doc.text("NURSING / TPA MONITORING SHEET", pageWidth / 2, y, { align: 'center' });
      y += 8;
  
      // ✅ FIXED: Changed 'item' to 'formData'
      const patientDetailsBody = [
          [
              { content: 'UHID', styles: { fontStyle: 'bold' } }, `: ${formData.med_uhid || 'N/A'}`,
              { content: 'IPD No.', styles: { fontStyle: 'bold' } }, `: ${formData.med_ipd || 'N/A'}`,
          ],
          [
              { content: 'Patient Name', styles: { fontStyle: 'bold' } }, `: ${formData.med_sheet_patient || 'N/A'}`,
              { content: 'Room/Bed', styles: { fontStyle: 'bold' } }, `: ${getWardNameById(formData.med_sheet_room) || 'N/A'}`,
          ],
          [
              { content: 'Consultant', styles: { fontStyle: 'bold' } }, `: ${getDoctorNameById(formData.med_sheet_consultant) || 'N/A'}`,
              { content: 'Panel', styles: { fontStyle: 'bold' } }, `: ${getBedNameById(formData.med_sheet_panel) || 'N/A'}`,
          ],
          [
              { content: 'Report Date', styles: { fontStyle: 'bold' } }, `: ${formatDateToDDMMMYYYY(formData.med_sheet_date)}`, // ✅ UPDATED
              { content: 'Report Time', styles: { fontStyle: 'bold' } }, `: ${formatTimeTo12Hour(formData.med_sheet_time)}`, // ✅ UPDATED
          ],
      ];
  
      autoTable(doc, {
          body: patientDetailsBody,
          startY: y,
          theme: 'plain',
          styles: { fontSize: 10, cellPadding: 1 },
          columnStyles: {
              0: { cellWidth: 30 }, 1: { cellWidth: 65 },
              2: { cellWidth: 30 }, 3: { cellWidth: 'auto' },
          },
      });
      y = doc.lastAutoTable.finalY + 10;
  
      doc.setFontSize(12).setFont('helvetica', 'bold');
      doc.text("Medicine Details", 15, y);
      y += 3;
  
      let medicines = [];
  
      try {
          if (typeof formData.med_sheet_medicine === "string") {
              medicines = JSON.parse(formData.med_sheet_medicine);
          } else {
              medicines = formData.med_sheet_medicine;
          }
      } catch (e) {
          medicines = [];
      }
  
      if (Array.isArray(medicines) && medicines.length > 0) {
          const medicineBody = medicines.map((med, index) => [
              index + 1,
              med.med_name || 'N/A',
              med.qty || 'N/A'
          ]);
  
          autoTable(doc, {
              head: [['#', 'Medicine Name', 'Quantity']],
              body: medicineBody,
              startY: y,
              theme: 'grid',
              styles: { fontSize: 10, cellPadding: 2, halign: 'center' },
              headStyles: { fillColor: [220, 220, 220], textColor: 20 },
              columnStyles: {
                  0: { cellWidth: 15 },
                  1: { cellWidth: 100, halign: 'left' },
                  2: { cellWidth: 40 }
              }
          });
  
          y = doc.lastAutoTable.finalY + 10;
      } else {
          doc.setFontSize(10).setFont('helvetica', 'normal');
          doc.text("No medicine record found.", 15, y);
          y += 10;
      }
  
      doc.setFontSize(12).setFont('helvetica', 'bold');
      doc.text("Consultant's / Nurse's Notes", 15, y);
      y += 3;
  
      const notesBody = formData.l1.map(item => [
          item.med_sheet_date || 'N/A',
          item.med_sheet_time || 'N/A',
          item.med_sheet_remark || 'N/A'
      ]);
  
      autoTable(doc, {
          head: [['Date', 'Time', 'Notes/Observations']],
          body: notesBody,
          startY: y,
          theme: 'grid',
          headStyles: { fillColor: [220, 220, 220], textColor: 20 },
          styles: { fontSize: 10 },
      });
      y = doc.lastAutoTable.finalY;
  
      const pageHeight = doc.internal.pageSize.getHeight();
      const footerY = pageHeight - 25;
      doc.setLineWidth(0.5);
      doc.line(15, footerY, 195, footerY);
      doc.setFontSize(10).setFont('helvetica', 'normal');
      doc.text("Nurse's Signature", 35, footerY + 8, { align: 'center' });
      doc.text("Consultant's Signature", 175, footerY + 8, { align: 'center' });
      doc.setFontSize(8).setFont('helvetica', 'italic');
      doc.text("This is a computer-generated report and does not require a physical signature.", pageWidth / 2, pageHeight - 10, { align: 'center' });
  
      window.open(doc.output('bloburl'), '_blank');
  };

    const handleCancel = () => {
        setFormData(prev => ({
            ...prev,
            med_sheet_id: '',
            med_sheet_ipd_number: '',
            med_sheet_patient: '',
            med_sheet_consultant: '',
            med_sheet_given_by: '',
            med_sheet_medicine: '',
            med_uhid: '',
            med_sheet_room: '',
            med_sheet_panel: '',
            med_sheet_remark: '',
        }));
        setSelectedMedicines([]);
        setHasLoadedPrefill(false);
    };

    const generatePDFPrint = async (formData, item) => {
      if (!item) {
          Swal.fire("Error", "Row data is not available.", "error");
          return;
      }
  
      const doc = new jsPDF('p', 'mm', 'a4');
      const pageWidth = doc.internal.pageSize.getWidth();
      let y;
  
      const headerImageBase64 = await imageUrlToBase64(image);
      const headerImageHeight = 30;
  
      if (headerImageBase64) {
          doc.addImage(headerImageBase64, 'PNG', 0, 0, pageWidth, headerImageHeight);
      }
      y = headerImageHeight + 8;
  
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(14);
      doc.text("NURSING / TPA MONITORING SHEET", pageWidth / 2, y, { align: 'center' });
      y += 8;
  
      // ✅ FIXED: Use 'item' for all fields, not 'formData'
      const patientDetailsBody = [
          [
              { content: 'UHID', styles: { fontStyle: 'bold' } }, `: ${item.med_uhid || 'N/A'}`,
              { content: 'IPD No.', styles: { fontStyle: 'bold' } }, `: ${item.med_ipd || 'N/A'}`, // ✅ Changed from formData to item
          ],
          [
              { content: 'Patient Name', styles: { fontStyle: 'bold' } }, `: ${item.med_sheet_patient || 'N/A'}`,
              { content: 'Room/Bed', styles: { fontStyle: 'bold' } }, `: ${getWardNameById(item.med_sheet_room) || 'N/A'}`,
          ],
          [
              { content: 'Consultant', styles: { fontStyle: 'bold' } }, `: ${getDoctorNameById(item.med_sheet_consultant) || 'N/A'}`,
              { content: 'Panel', styles: { fontStyle: 'bold' } }, `: ${getBedNameById(item.med_sheet_panel) || 'N/A'}`,
          ],
          [
              { content: 'Report Date', styles: { fontStyle: 'bold' } }, `: ${formatDateToDDMMMYYYY(item.med_sheet_date)}`, // ✅ Changed from formData to item
              { content: 'Report Time', styles: { fontStyle: 'bold' } }, `: ${formatTimeTo12Hour(item.med_sheet_time)}`, // ✅ Changed from formData to item
          ],
      ];
  
      autoTable(doc, {
          body: patientDetailsBody,
          startY: y,
          theme: 'plain',
          styles: { fontSize: 10, cellPadding: 1 },
          columnStyles: {
              0: { cellWidth: 30 }, 1: { cellWidth: 65 },
              2: { cellWidth: 30 }, 3: { cellWidth: 'auto' },
          },
      });
      y = doc.lastAutoTable.finalY + 10;
  
      doc.setFontSize(12).setFont('helvetica', 'bold');
      doc.text("Medicine Details", 15, y);
      y += 3;
  
      let medicines = [];
      try {
          if (typeof item.med_sheet_medicine === "string") {
              medicines = JSON.parse(item.med_sheet_medicine);
          } else {
              medicines = item.med_sheet_medicine;
          }
      } catch (e) {
          medicines = [];
      }
  
      if (Array.isArray(medicines) && medicines.length > 0) {
          const medicineBody = medicines.map((med, index) => [
              index + 1,
              med.med_name || 'N/A',
              med.qty || 'N/A'
          ]);
  
          autoTable(doc, {
              head: [['#', 'Medicine Name', 'Quantity']],
              body: medicineBody,
              startY: y,
              theme: 'grid',
              styles: { fontSize: 10, cellPadding: 2, halign: 'center' },
              headStyles: { fillColor: [220, 220, 220], textColor: 20 },
              columnStyles: {
                  0: { cellWidth: 15 },
                  1: { cellWidth: 100, halign: 'left' },
                  2: { cellWidth: 40 }
              }
          });
  
          y = doc.lastAutoTable.finalY + 10;
      } else {
          doc.setFontSize(10).setFont('helvetica', 'normal');
          doc.text("No medicine record found.", 15, y);
          y += 10;
      }
  
      doc.setFontSize(12).setFont('helvetica', 'bold');
      doc.text("Doctor's / Nurse's Notes", 15, y);
      y += 3;
  
      autoTable(doc, {
          head: [['Date', 'Time', 'Notes/Observations']],
          body: [[
              formatDateToDDMMMYYYY(item.med_sheet_date) || 'N/A', // ✅ Added formatting
              formatTimeTo12Hour(item.med_sheet_time) || 'N/A',     // ✅ Added formatting
              item.med_sheet_remark || 'N/A'
          ]],
          startY: y,
          theme: 'grid',
          headStyles: { fillColor: [220, 220, 220], textColor: 20 },
          styles: { fontSize: 10 },
      });
      y = doc.lastAutoTable.finalY;
  
      const pageHeight = doc.internal.pageSize.getHeight();
      const footerY = pageHeight - 25;
      doc.setLineWidth(0.5);
      doc.line(15, footerY, 195, footerY);
      doc.setFontSize(10).setFont('helvetica', 'normal');
      doc.text("Nurse's Signature", 35, footerY + 8, { align: 'center' });
      doc.text("Doctor's Signature", 175, footerY + 8, { align: 'center' });
      doc.setFontSize(8).setFont('helvetica', 'italic');
      doc.text("This is a computer-generated report and does not require a physical signature.", pageWidth / 2, pageHeight - 10, { align: 'center' });
  
      window.open(doc.output('bloburl'), '_blank');
  };

    // ==================== DATE SEARCH HANDLER ====================
    const handleDateSearch = async (date) => {
        setSearchDate(date);

        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            const fd = new FormData();
            fd.append('page_no', '0');
            fd.append('search_key', '');
            fd.append('search_date', date);
            fd.append('med_sheet_user', '1');

            try {
                const response = await axios.post(
                    AppConst.BASE_URL + AppConst.getMedSheetListUrl,
                    fd,
                    { headers: { 'Content-Type': 'multipart/form-data' } }
                );

                if (response.data.status) {
                    const records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            l1: records
                        }));
                    }
                }
            } catch (error) {
                console.error("Date search error:", error);
            }
        }
    };

    // ==================== DATATABLE COLUMNS ====================
    const columns = [

      {
        name: "Action",
        cell: (row) => (
            <div className="d-flex gap-1">
                <button
                    className="btn btn-sm btn-outline-info"
                    onClick={() => generatePDFPrint(formData, row)}
                    title="Print"
                >
                    <i className="ri-printer-line"></i>
                </button>
                <button
                    className="btn btn-sm btn-outline-warning"
                    onClick={() => handleEditClick(row)}
                    disabled={!isAdmin}
                    title="Edit"
                >
                    <i className="ri-pencil-fill"></i>
                </button>
                <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => delItem(row)}
                    disabled={!isAdmin}
                    title="Delete"
                >
                    <i className="ri-delete-bin-5-fill"></i>
                </button>
            </div>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        width: "140px",
    },
        {
            name: "Sr. No.",
            selector: (row, index) => index + 1,
            width: "80px",
            sortable: false,
        },
        {
        name: "Date",
        selector: (row) => formatDateToDDMMMYYYY(row.med_sheet_date), // ✅ UPDATED
        sortable: true,
        width: "120px",
    },
    {
        name: "Time",
        selector: (row) => formatTimeTo12Hour(row.med_sheet_time), // ✅ UPDATED
        sortable: true,
        width: "100px",
    },
        {
            name: "UHID",
            selector: (row) => row.med_uhid || "-",
            sortable: true,
            width: "120px",
        },
        {
            name: "Patient",
            selector: (row) => row.med_sheet_patient || "-",
            sortable: true,
            wrap: true,
            width: "180px",
        },
        {
            name: "Doctor",
            selector: (row) => getDoctorNameById(row.med_sheet_consultant) || "-",
            sortable: true,
            wrap: true,
            width: "150px",
        },
        {
            name: "Ward",
            selector: (row) => getWardNameById(row.med_sheet_room) || "-",
            sortable: true,
            width: "120px",
        },
        {
            name: "Bed",
            selector: (row) => getBedNameById(row.med_sheet_panel) || "-",
            sortable: true,
            width: "100px",
        },
        {
            name: "Medicine",
            selector: (row) => {
                let medicines = [];
                try {
                    medicines = typeof row.med_sheet_medicine === "string" 
                        ? JSON.parse(row.med_sheet_medicine) 
                        : row.med_sheet_medicine;
                } catch (e) {
                    medicines = [];
                }
                return medicines.map((med) => `${med.med_name} (${med.qty})`).join(", ");
            },
            wrap: true,
            width: "250px",
        },
        {
            name: "Given By",
            selector: (row) => row.med_sheet_given_by || "-",
            sortable: true,
            width: "130px",
        },
      
    ];

    const customStyles = {
        headCells: {
            style: {
                backgroundColor: "#f1f5fb",
                color: "#405189",
                fontSize: "14px",
                fontWeight: "700",
            },
        },
        rows: {
            style: {
                minHeight: "52px",
            },
        },
    };

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xxl-12">
                        <div className="card">
                            <div className="card-body">
                                <h5>Medical Sheet</h5>
                                <br />
                                
                                {/* Prefill indicator */}
                                {formData.med_sheet_ipd_number && !formData.med_sheet_id && (
                                    <div className="alert alert-info alert-dismissible fade show" role="alert">
                                        <i className="ri-information-line me-2"></i>
                                        <strong>Patient data loaded</strong> - UHID: {formData.med_sheet_ipd_number}
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    med_sheet_ipd_number: "",
                                                    med_sheet_patient: "",
                                                    med_sheet_consultant: "",
                                                    med_sheet_room: "",
                                                    med_sheet_panel: "",
                                                    med_uhid: "",
                                                    med_ipd:"",
                                                }));
                                            }}
                                        ></button>
                                    </div>
                                )}

                                <div className="live-preview">
                                    <form className="tablelist-form" onSubmit={handleSubmit}>
                                        <div className="modal-body">
                                            <input id="id-field" type="hidden" />
                                            <div className="row gy-4 mb-3">
                                                <div className="col-md-2">
                                                    <div className="mb-1 position-relative">
                                                        <label htmlFor="med-uhid-field" className="form-label">UHID Number</label>
                                                        <input
                                                            id="med-uhid-field"
                                                            name="med_sheet_ipd_number"
                                                            onChange={handleChange}
                                                            value={formData.med_sheet_ipd_number}
                                                            className="form-control"
                                                            placeholder="Enter UHID Number"
                                                            type="text"
                                                            onKeyUp={searchOtUserNow}
                                                            autoComplete="off"
                                                            required
                                                        />

                                                        {otUhidSuggestions.length > 0 && (
                                                            <ul className="list-group position-absolute w-100" style={{ zIndex: 10 }}>
                                                                {otUhidSuggestions.map((user, idx) => (
                                                                    <li
                                                                        key={idx}
                                                                        className="list-group-item list-group-item-action"
                                                                        onClick={() => handleSelectOtUser(user)}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        {user.lab_reg_uhid} - {user.lab_reg_name}
                                                                        <span className="badge bg-info ms-2">{user.lab_reg_type}</span>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
    <div className="mb-1">
        <label htmlFor="med-ipd-field" className="form-label">IPD Number</label>
        <input
            id="med-ipd-field"
            name="med_ipd"
            onChange={handleChange}
            value={formData.med_ipd}
            className="form-control"
            placeholder="IPD Number"
            type="text"
            readOnly
        />
    </div>
</div>
                                                <div className="col-md-2">
                                                    <div >
                                                        <label htmlFor="date-field" className="form-label">Patient</label>
                                                        <input className="form-control" name="med_sheet_patient" onChange={handleChange} value={formData.med_sheet_patient} data-provider="flatpickr" placeholder="Patient" type="text" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div >
                                                        <label htmlFor="date-field" className="form-label">OT Doctor</label>
                                                        <input className="form-control" name="med_sheet_consultant" onChange={handleChange} value={formData.med_sheet_consultant ? getDoctorNameById(formData.med_sheet_consultant) : ""}
                                                            data-provider="flatpickr" placeholder="Consultant" type="text" readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div >
                                                        <label htmlFor="date-field" className="form-label">Given By</label>
                                                        <input className="form-control" name="med_sheet_given_by" onChange={handleChange} value={formData.med_sheet_given_by} data-provider="flatpickr" placeholder="Given By" type="text" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div>
                                                        <label htmlFor="amount-field" className="form-label">Ward</label>
                                                        <input id="amount-field" className="form-control" name="med_sheet_room" onChange={handleChange} value={getWardNameById(formData.med_sheet_room)} placeholder="Room" type="text" readOnly />
                                                    </div>
                                                </div>

                                                <div className="col-md-2">
                                                    <div >
                                                        <label htmlFor="date-field" className="form-label">Bed</label>
                                                        <input className="form-control" name="med_sheet_panel" onChange={handleChange} value={getBedNameById(formData.med_sheet_panel)} data-provider="flatpickr" placeholder="Bed" type="text" readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div>
                                                        <label className="form-label">Medicine</label>
                                                        <Select
                                                            isMulti
                                                            options={options}
                                                            isLoading={loading}
                                                            onChange={handleSelectChange}
                                                            value={selectedMedicines}
                                                            placeholder="Select medicines..."
                                                        />

                                                        <div className="mt-3">
                                                            {selectedMedicines.map((med) => (
                                                                <div
                                                                    key={med.value}
                                                                    className="d-flex align-items-center mb-2 p-2 border rounded"
                                                                >
                                                                    <span className="me-3">{med.label}</span>
                                                                    <input
                                                                        type="number"
                                                                        min="1"
                                                                        name="med_sheet_qty"
                                                                        value={med.qty}
                                                                        onChange={(e) => handleQtyChange(Number(e.target.value), med.value)}
                                                                        className="form-control me-3"
                                                                        style={{ width: "80px" }}
                                                                    />
                                                                    <button
                                                                        className="btn btn-sm btn-danger"
                                                                        onClick={() => handleRemove(med.value)}
                                                                    >
                                                                        Remove
                                                                    </button>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>

                                                </div>

                                                <div className="col-md-2">
                                                    <div >
                                                        <label htmlFor="date-field" className="form-label">Date</label>
                                                        <input className="form-control" name="med_sheet_date" onChange={handleChange} value={formData.med_sheet_date} data-provider="flatpickr" placeholder="Date" type="date" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div >
                                                        <label htmlFor="date-field" className="form-label">Time</label>
                                                        <input className="form-control" name="med_sheet_time" onChange={handleChange} value={formData.med_sheet_time} data-provider="flatpickr" placeholder="Time" type="time" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div >
                                                        <label htmlFor="date-field" className="form-label">Remark</label>
                                                        <textarea className="form-control" name="med_sheet_remark" onChange={handleChange} value={formData.med_sheet_remark} data-provider="flatpickr" placeholder="Remark" type="text" ></textarea>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <div className="hstack gap-2 justify-content-end">
                                                <button type="button" className="btn btn-secondary" onClick={handleCancel}>Clear</button>
                                                {/* <button type="button" className="btn btn-info" onClick={generatePDF}>Print</button> */}
                                                <button type="submit" className="btn btn-success" id="edit-btn">Save</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                            </div>
                        </div>
                        <br />

                        {/* ==================== DATATABLE ==================== */}
                       {/* ==================== DATATABLE ==================== */}
{/* ==================== DATATABLE ==================== */}
{/* ==================== DATATABLE ==================== */}
<div className="card">
    <div className="card-header d-flex justify-content-between align-items-center">
        <h5 className="card-title mb-0">Medical Sheet Records</h5>
        <div className="d-flex gap-2 align-items-center">
            <label className="mb-0">From:</label>
            <input
                type="date"
                className="form-control"
                style={{ width: "150px" }}
                value={fromDate}
                onChange={(e) => {
                    const newFromDate = e.target.value;
                    setFromDate(newFromDate);
                    handleDateRangeSearch(newFromDate, toDate || newFromDate);
                }}
            />
            
            <label className="mb-0">To:</label>
            <input
                type="date"
                className="form-control"
                style={{ width: "150px" }}
                value={toDate}
                onChange={(e) => {
                    const newToDate = e.target.value;
                    setToDate(newToDate);
                    handleDateRangeSearch(fromDate || newToDate, newToDate);
                }}
            />
            {/* ✅ Icon-Only Clear Button */}
<button
    type="button"
    className="btn btn-outline-secondary"
    onClick={handleClearFilters}
    title="Clear filters and show today's records"
    style={{ minWidth: "40px" }}
>
    <i className="ri-refresh-line"></i>
</button>
            <input
                type="text"
                className="form-control"
                placeholder="Search patient..."
                style={{ width: "200px" }}
                value={searchKey}
                onChange={(e) => {
                    setSearchKey(e.target.value);
                    handleSearch(e.target.value);
                }}
            />
            
            {/* ✅ NEW: Clear Button */}
            <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClearFilters}
                title="Clear filters and show today's records"
            >
                <i className="ri-refresh-line me-1"></i>
                Clear
            </button>
        </div>
    </div>
    <div className="card-body">
        <DataTable
            columns={columns}
            data={formData.l1}
            pagination
            highlightOnHover
            responsive
            persistTableHead
            customStyles={customStyles}
            noHeader
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 20, 50]}
        />
    </div>
</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MedSheet;